import { Pipe, PipeTransform } from '@angular/core';
import { mapBrandLabel } from '../../core/constants/brand-label';

/**
 * Renames champion -> FitX and premium -> ZoneX for display only.
 * Usage: {{ item.subscriptionCategoryName | brandLabel }}
 */
@Pipe({
    name: 'brandLabel',
    standalone: true,
})
export class BrandLabelPipe implements PipeTransform {
    transform(value: any): any {
        return mapBrandLabel(value);
    }
}
